import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "btn1",
  "use": "btn1-usage",
  "viewBox": "0 0 316 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 316 125\" id=\"btn1\"><path fill-rule=\"evenodd\" d=\"M-0.000,-0.000 L316.000,-0.000 L316.000,125.000 L-0.000,125.000 L-0.000,-0.000 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol